declare namespace $ {

	type $mol_view__sub_bog_smalljs_docs_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_docs_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['menu_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_docs_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['sidebar_groups'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_text__text_bog_smalljs_docs_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['page_md'] >
		,
		ReturnType< $bog_smalljs_text['text'] >
	>
	type $mol_link__uri_bog_smalljs_docs_6 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['edit_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_smalljs_docs_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['feedback_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['nav_links'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_12 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['toc_links'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_18 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['group_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_docs_20 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['link_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_docs_21 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['nav_click'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__sub_bog_smalljs_docs_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_bog_smalljs_docs_23 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['toc_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_docs_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_docs_26 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['feedback_yes'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_docs_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_docs_28 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['feedback_no'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_docs_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_docs_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_docs_31 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['prev_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_docs_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_bog_smalljs_docs_33 = $mol_type_enforce<
		ReturnType< $bog_smalljs_docs['next_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_docs_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $bog_smalljs_docs extends $mol_view {
		scroll_reset( ): any
		menu_toggle( next?: any ): any
		Menu_icon( ): $mol_icon_menu
		Menu_label( ): $mol_view
		Menu_toggle( ): $mol_button_minor
		sidebar_groups( ): readonly(any)[]
		Sidebar( ): $mol_view
		Body( ): $bog_smalljs_text
		Edit_icon( ): $mol_icon_pencil
		Edit_label( ): string
		Edit( ): $mol_link
		feedback_content( ): readonly(any)[]
		Feedback( ): $mol_view
		nav_links( ): readonly(any)[]
		Nav( ): $mol_view
		Main( ): $mol_view
		toc_title_text( ): string
		Toc_title( ): $mol_view
		toc_links( ): readonly(any)[]
		Toc_list( ): $mol_view
		Toc( ): $mol_view
		group_content( id: any): readonly(any)[]
		group_title_text( id: any): string
		link_arg( id: any): Record<string, any>
		nav_click( next?: any ): any
		link_title( id: any): string
		toc_arg( id: any): Record<string, any>
		toc_text( id: any): string
		feedback_prompt_text( ): string
		feedback_yes( next?: any ): any
		Feedback_yes_icon( ): $mol_icon_thumb_up
		feedback_yes_label( ): string
		feedback_no( next?: any ): any
		Feedback_no_icon( ): $mol_icon_thumb_down
		feedback_no_label( ): string
		feedback_thanks_text( ): string
		prev_arg( ): Record<string, any>
		prev_hint_text( ): string
		Prev_hint( ): $mol_view
		prev_title( ): string
		Prev_title( ): $mol_view
		next_arg( ): Record<string, any>
		next_hint_text( ): string
		Next_hint( ): $mol_view
		next_title( ): string
		Next_title( ): $mol_view
		page( ): string
		page_md( ): string
		title_text( ): string
		edit_uri( ): string
		sidebar_open( next?: boolean ): boolean
		attr( ): ({ 
			'bog_smalljs_sidebar_open': ReturnType< $bog_smalljs_docs['sidebar_open'] >,
		}) 
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
		Group( id: any): $mol_view
		Group_title( id: any): $mol_view
		Link( id: any): $mol_link
		Toc_link( id: any): $mol_link
		Feedback_prompt( ): $mol_view
		Feedback_yes( ): $mol_button_minor
		Feedback_no( ): $mol_button_minor
		Feedback_thanks( ): $mol_view
		Prev( ): $mol_link
		Next( ): $mol_link
	}
	
}

//# sourceMappingURL=docs.view.tree.d.ts.map